import React from 'react'

import { FormValues } from 'donate/types'
import { connect } from 'formik'

export const HolderTitle = connect<{}, FormValues>(({ formik }) => {
  return <h4>{i18n.t(`donate.holder_title.${formik.values.payment_method}`)}</h4>
})
